import { PhaserAudioManager } from '@/game/GameComponents/PhaserGame/Utils/PhaserAudioManager';
import { getScreenPosition } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import ProgressBar from '@/game/prefabs/GeneralUI/ProgressBar';
import ProgressBarSmall from '@/game/prefabs/GeneralUI/ProgressBarSmall';
import ProgressBarWithCheckbox from '@/game/prefabs/GeneralUI/ProgressBarWithCheckbox';
import _ from 'lodash';

export class ProgressBarBrain {
  constructor(progressBar: ProgressBarType) {
    this.progressBar = progressBar;
    if (!this.maskGraphics) {
      this.maskGraphics = this.progressBar.scene.add.graphics();
      this.progressBar.barFill.setMask(this.maskGraphics.createGeometryMask());
    }

    this.setProgressInstant(0);

    this.progressBar.scene.events.on('prerender', this.update, this);
  }

  public progressBar: ProgressBarType;
  private currentProgress: number = 0;
  private maskGraphics?: Phaser.GameObjects.Graphics;

  public get CurrentProgress() {
    return this.currentProgress;
  }

  update() {
    if (isNaN(this.progressBar.barMask.getBounds().width)) {
      this.progressBar.barMask.scaleX = 0.01;
      this.progressBar.barMask.setVisible(true);
    }

    this.maskGraphics?.clear();
    this.maskGraphics?.fillStyle(0xffffff, 0);
    const pos = getScreenPosition(this.progressBar.barMask);
    this.maskGraphics?.fillRect(
      pos.x,
      pos.y - this.progressBar.barMask.getBounds().height / 2, // offset becasuse of origin.
      this.progressBar.barMask.getBounds().width || 0,
      this.progressBar.barMask.getBounds().height || 0,
    );
  }

  setProgressInstant(progress: number) {
    const { progressBar } = this;

    progress = Math.max(0.001, Math.min(1, progress));
    this.currentProgress = progress;

    if (progressBar instanceof ProgressBarWithCheckbox) {
      progressBar.checkbox.setTexture(progress === 1 ? '8check06' : '8check05');
    }

    progressBar.barMask.scaleX = progress;
  }

  setProgressAnimated(progress: number) {
    const { progressBar } = this;
    progress = _.clamp(progress, 0, 1);
    if (progressBar instanceof ProgressBarWithCheckbox) {
      progressBar.checkbox.setTexture(progress === 1 ? '8check06' : '8check05');
    }

    this.setProgressInstant(this.currentProgress);

    progressBar.scene.tweens
      .add({
        targets: {
          cropWidth: this.currentProgress,
        },
        duration: 600,
        cropWidth: progress,
        ease: 'Expo.easeOut',
        onUpdate: (_tween, targets) => {
          progressBar.barMask.setScale(
            targets.cropWidth,
            progressBar.barMask.scaleY,
          );
        },
        onComplete: () => {
          this.currentProgress = progress;
        },
      })
      .play();

    PhaserAudioManager.playSFX(progressBar.scene, 'progress-increment');
  }

  setCheckmarkVisible(visible: boolean) {
    const { progressBar } = this;
    if (progressBar instanceof ProgressBarWithCheckbox) {
      progressBar.checkboxContainer.setVisible(visible);
    }
  }

  destroy() {
    this.progressBar.scene.events.off('prerender', this.update, this);
  }
}

export type ProgressBarType =
  | ProgressBar
  | ProgressBarWithCheckbox
  | ProgressBarSmall;
